module.exports = __webpack_public_path__ + "img/santa-btn.8602342a.svg";